// extracted by mini-css-extract-plugin
export var base = "_53-0";
export var updateBanner = "_53-1";